import { ElectionType } from "../models/election-type";
import { backend } from "../utils/axios";

const ROUTE = "/election-types";

export const ElectionTypeService = {
  getElectionTypes: async (): Promise<ElectionType[]> => {
    const { data } = await backend.get<ElectionType[]>(ROUTE);
    return data;
  },
};
